import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlaceholderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 55,
	height: 55,
	viewBox: "0 0 55 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.8965 0C29.9341 0 32.3965 2.46243 32.3965 5.5V22.3965H49.292C52.3296 22.3965 54.792 24.8589 54.792 27.8965C54.7918 30.9339 52.3295 33.3965 49.292 33.3965H32.3965V49.292C32.3965 52.3296 29.9341 54.792 26.8965 54.792C23.8589 54.792 21.3965 52.3296 21.3965 49.292V33.3965H5.5C2.46253 33.3965 0.000148563 30.9339 0 27.8965C-1.32776e-07 24.8589 2.46243 22.3965 5.5 22.3965H21.3965V5.5C21.3965 2.46243 23.8589 0 26.8965 0Z",
		fill: "white",
		fillOpacity: .85
	})
});
export default SvgPlaceholderIcon;
